import { Box } from "@mantine/core";
import { CSSProperties, FC, useRef } from "react";
import { Map, Marker } from "react-map-gl";

type LatLon = [number, number];

interface Props {
  latLon: LatLon;
  zoomLevel?: number;
  h?: number | string;
  w?: number | string;
  pinScale?: number;
  style?: CSSProperties;
  onPinPositionChange?: (p: LatLon) => void;
}

const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN;

const Minimap: FC<Props> = ({
  latLon,
  zoomLevel = 13,
  w = "100%",
  h = 200,
  pinScale = 0.7,
  style,
  onPinPositionChange,
}) => {
  const mapRef = useRef<mapboxgl.Map>();

  return (
    <Box h={h} w={w} style={style}>
      <Map
        ref={mapRef as any}
        mapStyle="mapbox://styles/mapbox/standard"
        mapboxAccessToken={mapboxToken}
        style={{
          width: '100%',
          height: '100%',
          top: '0',
          left: '0'
        }}
        onClick={(e) => {
          if (onPinPositionChange) {
            onPinPositionChange([e.lngLat.lat, e.lngLat.lng]);
          }
        }}
        initialViewState={{
          latitude: latLon[0],
          longitude: latLon[1],
          zoom: zoomLevel,
        }}>
        <Marker
          latitude={latLon[0]}
          longitude={latLon[1]}
          scale={pinScale}
        />
      </Map>
    </Box>
  );
};

export default Minimap;